export const VISITOR_MODE_COOKIE = 'visitor_mode'
export const VISITOR_COOKIE_MAX_AGE = 60 * 60

/** Força a tela de login mesmo com visitor_access ativo (proxy + useVisitorLoginRedirect). */
export const FORCE_LOGIN_HREF = '/?force_login=1'

export function isVisitorAccessEnabled(
  visitorAccess?: { enabled?: boolean | string } | null,
): boolean {
  if (!visitorAccess) return false
  return visitorAccess.enabled === true || visitorAccess.enabled === 'true'
}

export function parseVisitorAccessFromShowcase(showcase: unknown): boolean {
  if (!showcase || typeof showcase !== 'object') return false
  const visitorAccess = (showcase as Record<string, unknown>).visitor_access
  if (!visitorAccess || typeof visitorAccess !== 'object') return false
  return isVisitorAccessEnabled(visitorAccess as { enabled?: boolean | string })
}
